
const $ = window.jQuery;

import View from './view';
import Utils from '../utils/utils';
import '../modules/plugin.lazyload';
import '../modules/plugin.embeddedplayer';
import PerfectScrollbar from 'perfect-scrollbar';
import Flickity from 'flickity';

// GSAP
// https://www.youtube.com/watch?v=znVi89_gazE
import { gsap, CustomEase, ScrollToPlugin, Power4, Linear } from 'gsap/all';
gsap.registerPlugin(CustomEase, ScrollToPlugin);
gsap.registerEase(Linear, Power4);

export default class MainView extends View {

  /**
   * Constructor
   * @param {jQuery element} $el
   * @param {Store} store
   */
  constructor( $el, app, store, router ) {

    super( $el );

    this.app = app;
    this.store = store;
    this.router = router;

    $el.css({
      opacity: 1,
      visibility: 'visible'
    });

    $('html').toggleClass('is-mobile', this.isMobile());

    this.tweenDefaults = {
      duration: 0.8,
      ease: Power4.easeOut
    };

    this.isAutomatedScrolling = false;

    this.interaction();
    this.initRendered();

    this.adjustStage(0);
    this.selectProject(this.store.normalizeUrl( window.location.href ));

    $(window).resize( Utils.throttle( () => this.fit(), 10 ) );
    $(window).bind("orientationchange", Utils.throttle( () => this.fit(), 10 ) );
    $(document).scroll( () => this.scrollHandler() );
    $(document).on('new-content', () => this.fit() );

    sessionStorage.removeItem('expandedAccordeonItems');

    // setTimeout(() => this.titleAnimation(), 3000);

  }

  titleAnimation() {
    let $title = $('title:first');
    let titleText = $title.text();
    if( titleText.indexOf('□■') !== -1 ) {
      titleText = titleText.replace('□■', '■□');
    } else {
      titleText = titleText.replace('■□', '□■');
    }
    $title.text(titleText);
    setTimeout(() => this.titleAnimation(), 3000);
  }

  fit() {
    this.fitVerticalHeight();
    this.adjustViewportRatio();
    this.fitImages();
    this.adjustScrollbars();
    this.fitSvgTextElements();
    this.fitNavsToColumns($('.stage_column'));
  }

  /**
   * Fit SVGs to their first text child's width and height
   */
  fitSvgTextElements() {
    const elements = document.querySelectorAll('svg.text');
    for( const el of elements ) {
      const box = el.querySelector('text').getBBox();
      // el.setAttribute('viewBox', `${box.x} ${box.y} ${box.width} ${box.height}`);
      // el.style.width = `${box.width}px`;
      // el.style.height = `${box.height}px`;
      el.setAttribute('width', box.width);
      el.setAttribute('height', box.height);

    }
  }

  fitVerticalHeight() {
    let vhOuter = document.documentElement.clientHeight;
    let vhInner = $(window).height();

    if( this.isMobile() ) {
      if( this.mobileHeightSet ) {
        return;
      }
      vhOuter = window.innerWidth < window.innerHeight ? window.screen.height : window.screen.width;
      this.mobileHeightSet = true;
    }
    document.documentElement.style.setProperty('--vh-outer', vhOuter + 'px');
    document.documentElement.style.setProperty('--vh', vhInner + 'px');
  }

  adjustViewportRatio() {
    let ratio = $(window).width() / $(window).height();
    document.documentElement.style.setProperty('--ratio', ratio);
  }

  interaction() {

    // disable links with only #
    $(document).on('click', 'a[href=\\#]', (e) => {
      e.preventDefault();
      e.stopPropagation();
    });

    // scroll to links starting with #some-selector
    $(document).on('click', 'a[href^=\\#]:not([href=\\#])', (e) => this.anchorLinkHandler(e) );

  }

  anchorLinkHandler( e ) {
    let $anchor = $(e.target).closest('a');
    let href = $anchor.attr('href');
    let $el = $(href);
    if( !$el.length ) {
      return true;
    }
    e.preventDefault();
    e.stopPropagation();

    let top = $el.offset().top;
    top -= $('.header--main').outerHeight();
    top += 1;

    this.scrollTo( top );
  }

  scrollTo( pos, options ) {

    let settings = $.extend(
      {
        element: 'html',
        silent: false,
        onComplete: () => {}
      },
      this.tweenDefaults,
      options
    );

    this.isAutomatedScrolling = true;
    if( !settings.silent ) this.scrollHandler();

    gsap.to( settings.element, settings.duration, {
      scrollTo:{
        y: pos,
        autoKill: true
      },
      overwrite: true,
      ease: settings.ease
    });

    clearTimeout( this.scrollTimeout );
    this.scrollTimeout = setTimeout( () => {
      this.isAutomatedScrolling = false;
      if( !settings.silent ) this.scrollHandler();
      settings.onComplete();
    }, settings.duration * 1000 );
  }

  scrollHandler() {

    const documentBottom = $(document).height() - $(window).height();
    const scrollTop = Math.max( 0, Math.min(documentBottom, $(document).scrollTop() ) );

    if( !this.isAutomatedScrolling ) {

    }

  }

  render( data ) {

    let $document = data.$document.clone();

    let bodyClass = $document.find('#container').attr('class');

    // replace document title
    let $newTitle = $document.find('title:first');
    let $currentTitle = $(document).find('title:first');
    if( $currentTitle.length && $newTitle.length ) {
      $currentTitle.html( $newTitle.html() );
    }

    let $mainView = $document.find('#mainview');
    let $languageSwitcher = $document.find('#menu_language-switcher');

    this.$el.reveal('destroy');
    $('.lazyload').lazyload('destroy');

    if( this.renderFragments( $mainView ) ) {
      this.initRendered('fragments');
    } else {
      this.fade(0).then(() => {
        this.$el.attr('class', bodyClass );
        $('#mainview').replaceWith( $mainView );
        $('#menu_language-switcher').replaceWith( $languageSwitcher );
        this.initRendered();
        this.fade(1, 0.2, 0.1);
      });
    }

  }

  fade( value, speed = 0.1, delay = 0 ) {
    return new Promise((resolve, reject) => {
      gsap.to( $('#container'), speed, {
        opacity: value,
        ease: Linear.easeNone,
        delay: delay,
        onComplete: () => resolve()
      })
    })
  }

  renderFragments( $doc ) {
    let fragmentsFound = 0;
    $doc.find('[data-fragment-id]').each((i, el) => {
      let $fragment = $(el);
      let fragmentId = $fragment.data('fragment-id');
      let $placeholder = this.$el.find(`[data-fragment-placeholder="${fragmentId}"]`);
      if( $placeholder.length ) {
        fragmentsFound ++;
        $placeholder.replaceWith( $fragment );
      }
    })
    return fragmentsFound > 0;
  }

  initRendered( mode = 'full' ) {

    this.initProjectsSlider();

    this.fit();

    $('html').removeClass('is-loading');

    this.preload();

    $('.video').embeddedPlayer();

    this.adjustActiveClasses();

    this.fit();

    this.initVideos();


    switch( mode ) {
      case 'full':
        $('body').trigger('mainView:render');
        this.scrollAtRender();
        break;
      case 'fragments':
        // this.scrollToElement( this.$el.find('.frontend-form:first'), {
        //   offset: -190
        // });
        break;
    }

    this.$el.find('.lazyload').one('lazyloaded', e => this.adjustImageCredits($(e.currentTarget)));
    this.$el.find('.lazyload').lazyload();
  }

  preload() {
    $('a.preload').each((i, el) => {
      this.store.loadPage( $(el).attr('href'), {
        silent: true
      })
    })
  }

  adjustStage(duration = 1) {
    const $columns = $('.stage_column');

    let $selectedColumn = $(`.stage_column[data-url="${window.location.href}"]`);
    if( !$selectedColumn.length ) {
      $selectedColumn = $('.stage_column').eq(1);
    }
    if( $selectedColumn.hasClass('is-selected') ) return;
    $columns.removeClass('is-selected').find('>.single').removeClass('is-selected');
    $selectedColumn.addClass('is-selected').find('>.single').addClass('is-selected');
    const index = $selectedColumn.index();
    const $stage = $('.stage');

    const $navs = $('.nav');
    $navs.removeClass('is-selected');
    $navs.eq(index).addClass('is-selected');

    gsap.to($stage, duration, {
      transform: `translateX(${index * -100}vw)`,
      ease: CustomEase.create("custom", "M0,0 C0.188,0 0.192,0.726 0.318,0.852 0.45,0.984 0.504,1 1,1"),
      onUpdate: () => this.fitNavsToColumns($columns),
      onComplete: () => {
        $stage.css({
          transform: `translateX(${index * -100}vw)`,
        })
        this.showScrollbarsForSelected();
      }
    });
  }

  fitNavsToColumns($columns) {
    const $navs = $('.nav');
    const windowWidth = $(window).width();
    $columns.each((i, el) => {
      const $nav = $navs.eq(i);
      const rect = el.getBoundingClientRect();
      const left = rect.left;
      const right = windowWidth - rect.right;
      $nav.css({
        'clip-path': `inset(0px ${right}px 0px ${left}px)`,
        '-webkit-clip-path': `inset(0px ${right}px 0px ${left}px)`
      });
    })
  }

  initProjectsSlider() {

    this.$el.find('.projects').each((i, el) => {
      const $el = $(el);
      $el.find('.single-project:first').addClass('is-first').attr('data-url', window.GLOBALS.homeUrl);
      let $first = $el.find(`.single-project[data-url="${window.location.href}"]`);
      if( !$first.length ) $first = $('.single-project:first');
      const initialIndex = $first.index();
      const f = new Flickity(el,{
        adaptiveHeight: false,
        setGallerySize: false,
        prevNextButtons: false,
        pageDots: false,
        wrapAround: true,
        cellAlign: 'center',
        accessibility: false,
        draggable: !this.supportsHover(),
        dragThreshold: 10,
        initialIndex: initialIndex
      });
      $(el).data('flickity', f);
      f.on('change', index => this.onProjectsSliderChange());
      f.on('settle', index => this.showScrollbarsForSelected());
      f.on('dragMove', index => {this.hideScrollbars(true)});

      $el.find('.flkty-button--previous').click(() => f.previous());
      $el.find('.flkty-button--next').click(() => f.next());
      $el.find('.module-project-header .video').each((i,el) => {
        const $video = $(el);
        const $overlay = $('<div class="video_overlay"></div>');
        $video.prepend($overlay);
      })
      f.on('staticClick', e => this.onFlickityStaticClick(e) )
    })
    this.onProjectsSliderChange(false);
    setTimeout(() => {
      this.hideScrollbars();
      this.showScrollbarsForSelected();
    }, 1);

  }

  onFlickityStaticClick( e ) {
    if( !e.target.classList.contains('video_overlay') ) return;
    const $video = $(e.target.parentNode);
    $video.embeddedPlayer('togglePlay');
  }

  onProjectsSliderChange( triggerRouter = true ) {
    const $project = $('.single-project.is-selected');
    // reset videos
    $('.single-project:not(.is-selected) .video').embeddedPlayer('reset');
    // adjust color
    const color = $project.attr('data-highlight-color');
    if( color ) {
      document.documentElement.style.setProperty('--highlight-color', color);
      this.createFavicon(color);
    }
    // adjust router
    const projectUrl = $project.attr('data-url');
    if( triggerRouter && projectUrl !== window.location.href ) {
      this.router.navigate(projectUrl);
    }
    // adjust nav backlinks
    $('.nav .backlink').attr('href', $project.attr('data-url'));
  }

  showScrollbarsForSelected() {
    requestAnimationFrame(() => {
      for( const $el of this.el.querySelectorAll('.single.is-selected .scrollable') ) {
        $el.classList.remove('hide-scrollbars');
      }
    })
  }


  selectProject(url) {
    let $project = $(`.single-project[data-url="${url}"]:not(.is-selected)`);
    if( $project.length ) {
      let f = $project.parents('.flickity-enabled:first').data('flickity');
      f.selectCell( $project[0], true, !$('.stage_column:nth-child(2)').hasClass('is-selected') );
      return true;
    }
    return false;
  }

  hideScrollbars( all = false ) {
    const selector = all ? '.single .scrollable' : `.single:not([data-url="${window.location.href}"]) .scrollable`;
    for( const $el of this.el.querySelectorAll(selector) ) {
      const scrollTop = $el.scrollTop;
      $el.classList.add('hide-scrollbars');
      if( scrollTop > 0 ) {
        $el.scrollTop = scrollTop;
        this.scrollTo(0, {
          element: $el
        });
      }
    }

  }

  createFavicon(color) {
    return;
    const canvas = document.createElement("CANVAS");
    const ctx = canvas.getContext("2d");
    canvas.classList.add('favicon');
    ctx.font = "30px Prohpet";
    ctx.fillStyle = color;
    ctx.fillText("Hello World", 10, 50);
    document.body.appendChild(canvas);
  }

  scrollAtRender() {
    let scrollPositions = this.store.getPageData( 'scrollPositions', window.location.href, {} );
    let hash = window.location.hash.split('/').join('-');

    $('[data-scrollable-id]').each((i, el) => {
      const $el = $(el);
      const id = el.getAttribute('data-scrollable-id');
      const cachedScrollTop = parseInt( scrollPositions[id] || 0, 10 );

      if(
        cachedScrollTop === -1
        && hash
        && $el.find(hash).length
        && $el.find(hash).parents('[data-scrollable-id]:first').is($el) ) {
        this.scrollToElement( $el.find(hash), 0, {element: el, duration: 0} );
      } else {
        this.scrollTo(cachedScrollTop, {element: el, duration: 0})
      }

    })
  }

  scrollToElement( $el, offset = 0, options = {} ) {
    if( !$el.length ) return false;
    this.scrollTo( $el.offset().top - offset, options );
    return true;
  }

  fitImages() {
    $('.fit-images-with-js .scaled-media').each((i, el) => {
      let $wrap = $(el);
      let wrapRatio = $wrap.width() / $wrap.height();
      let $img = $wrap.find('img');
      let imgRatio = $img.data('ratio');
      $img.toggleClass('is-wider', imgRatio > wrapRatio);
    });
  }

  adjustActiveClasses() {
    return;
    let currentUrl = window.location.href;
    $('a').each((i, el) => {
      let $el = $(el);
      let href = $el.data('href-for-active-check');
      if( typeof href === 'undefined' ) {
        href = $el.attr('href');
      }
      if( typeof href === 'undefined' ) {
        return true;
      }
      if( $el.hasClass('skip-active-check') ) {
        return true;
      }
      $el.removeClass('is-active');
      if( !$el.hasClass('active-if-exact') && currentUrl.indexOf( href ) !== -1 ) {
        $el.addClass('is-active');
      } else if( currentUrl === href ) {
        $el.addClass('is-active');
      }
    })

  }

  adjustScrollbars() {

    $('.scrollable').each((i, el) => {

      let $el = $(el);
      let ps = this.getData( 'ps', $el );
      if( ps ) ps.update();

      let isPsActive = this.watchCss(el, 'ps-active');

      if( isPsActive ) {
        this.initScrollbar( $el );
      } else {
        this.destroyScrollbar( $el );
      }

    })
  }

  getData( key, $el ) {
    let data = $el.data(key);
    return typeof data !== 'undefined' ? data : false;
  }

  destroyScrollbar( $el ) {
    let ps = this.getData( 'ps', $el );
    if( !ps ) return;
    ps.destroy();
    ps = null;
    $el.removeData('ps');
  }

  initScrollbar( $el ) {
    let ps = this.getData( 'ps', $el );
    if( ps ) return;
    ps = new PerfectScrollbar( $el.get(0), {
      // maxScrollbarLength: 100,
      suppressScrollX: true
    });
    $el.data('ps', ps);
  }

  /**
   * Detects if the window dimensions are almost the screens dimensions
   * and the device doesn't support hovering
   */
  isMobile() {
    let widthDiff = window.screen.width - window.innerWidth;
    let heightDiff = window.screen.height - window.innerHeight;
    return !this.supportsHover() && heightDiff < 150 && widthDiff < 150;
  }

  /**
   * Detects hover support
   */
  supportsHover() {
    return window.matchMedia("screen and (hover: hover), screen and (min--moz-device-pixel-ratio: 0), screen and (-ms-high-contrast:none)").matches;
  }

  adjustImageCredits($images) {
    $images.filter(":not([data-brightness])").each((i, el) => {
      let $img = $(el);
      let brightness = Utils.getColorBrightness( Utils.getAverageRGB(el) );
      let $image_credits = $img.parents('.scaled-media').find('.image_credits');
      $img.attr('data-brightness', brightness);
      $image_credits
        .removeClass('is-hidden')
        .addClass( brightness > 70 ? 'is-black' : 'is-white')
        .click( e => { e.stopPropagation() });
    });
  }

  watchCss( el, compare, where = 'before' ) {
    var afterContent = getComputedStyle( el, `:${where}` ).content;
    return afterContent.indexOf(compare) != -1;
  }

  initVideos() {
    $('[data-video-src]').each((i, el) => {
      let $el = $(el);
      let src = $el.data('video-src');
      let classes = $el.attr('class');
      let $video = $(`
        <video class="${classes}" src="${src}"
          autoplay loop muted playsinline
          onloadedmetadata="this.muted = true">
        </video>
      `);
      $el.replaceWith($video);
      $video.one('timeupdate', () => { $video.addClass('is-playing') });
    });
  }
}